// Identifies this client to the backend so it can gate sessions by client.
// Only the routes that mint or renew a session are inspected, so the header is
// attached to those alone. As a blanket default it also rode on requests whose
// response redirects cross-origin — the invoice PDF 302s to a presigned S3 URL
// — where a custom header forces a preflight the media bucket does not allow,
// and the file silently fails to load.
export const CLIENT_HEADER = "X-Client"
export const WEB_CLIENT_ID = "web"

const SESSION_ROUTE = /(^|\/)auth\//

// The notification feed is filtered by what this client can render: the backend
// withholds a notification type from any caller that has not named itself as
// able to show it (`apps/notifications_app/client_support.py`), because the
// mobile builds mirror that enum by hand and ship on their own schedule.
// Without the header here the web app would be treated as one of those old
// builds and would stop seeing messaging notifications.
const CLIENT_AWARE_ROUTE = /(^|\/)notifications\//

export const isSessionRoute = (url?: string): boolean =>
  Boolean(url && SESSION_ROUTE.test(url))

/** Routes whose response depends on which client is asking. */
export const needsClientHeader = (url?: string): boolean =>
  Boolean(url && (SESSION_ROUTE.test(url) || CLIENT_AWARE_ROUTE.test(url)))

export const clientHeaders = (): Record<string, string> => ({
  [CLIENT_HEADER]: WEB_CLIENT_ID
})
